import React, { createRef, useEffect, useRef } from "react";

interface NumberInputCipherProps {
    onFinish: (v:number) => void;
}

export default function NumberInputCipher(props: NumberInputCipherProps) {

    const ref = createRef<HTMLInputElement>();

    useEffect(() => {
        window.addEventListener("clearNumberInput", () => {
            if (ref.current) {
                ref.current.value = "";
                if(!ref.current.previousSibling) {
                    ref.current.focus();
                }
            }
            
        });
    }, [ref]);

    function pasteInNumberInput(i: number, text: string, e: HTMLInputElement) {
        e.focus();
        setTimeout(() => {
            e.value = text.charAt(i);
            e.dispatchEvent(new Event("change"));
            if(e.nextSibling && text.length > i+1 && e.nextSibling instanceof HTMLInputElement) {
                pasteInNumberInput(i+1, text, e.nextSibling as HTMLInputElement);
            }
            if(!e.nextSibling) {
                finish(e);
            }
        }, 10);
    }

    function finish(sibling: HTMLInputElement) {
        var value = "" + sibling.value;
        while(sibling?.previousSibling) {
            sibling = sibling.previousSibling as HTMLInputElement;
            value += sibling.value;
        }
        props.onFinish(Number(reverseString(value)));
    }

    return <input ref={ref} onPaste={(e) => {
        var clipboardData, pastedData;

        // Stop data actually being pasted into div
        e.stopPropagation();
        e.preventDefault();

        // Get pasted data via clipboard API
        clipboardData = e.clipboardData;
        pastedData = clipboardData.getData('Text');
        pasteInNumberInput(0, pastedData, e.target as HTMLInputElement);
    }} onInput={(e) => {
        var el  = e.target as HTMLInputElement;
        el.value = el.value.replace(/\D+/g, '');
    }} onKeyDown={(e) => {
        if(e.keyCode == 8 || e.keyCode == 46) {
            var el = e.target as HTMLInputElement;
            if(el.previousElementSibling) {
                (el.previousElementSibling as HTMLInputElement).focus();
                (el.previousElementSibling as HTMLInputElement).value = "";
            }
        }
    }} onFocusCapture={(e) => {
        e.target.value = "";
    }} onChange={(e) => {
        console.log("change");
        if (e.target.nextSibling) {
            (e.target.nextSibling as HTMLElement).focus();
        }else {
            finish(e.target as HTMLInputElement);
        }
    }} type="number" className="number-input-cipher"/>;
}

function reverseString(str: string) {
    // Step 1. Use the split() method to return a new array
    var splitString = str.split(""); // var splitString = "hello".split("");
    // ["h", "e", "l", "l", "o"]

    // Step 2. Use the reverse() method to reverse the new created array
    var reverseArray = splitString.reverse(); // var reverseArray = ["h", "e", "l", "l", "o"].reverse();
    // ["o", "l", "l", "e", "h"]

    // Step 3. Use the join() method to join all elements of the array into a string
    var joinArray = reverseArray.join(""); // var joinArray = ["o", "l", "l", "e", "h"].join("");
    // "olleh"

    //Step 4. Return the reversed string
    return joinArray; // "olleh"
}